export default __webpack_public_path__ + "static/138-a957fd7bf2e06f64cbd9358d6a1ba8fc.gif";